import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'truventor-engage';
  showSidepanel: boolean = false;
  isMaximized: boolean = false;;

  toggleSidepanel() {
    this.showSidepanel = !this.showSidepanel;
  }

  maximizeSidepanel() {
    this.isMaximized = true;
  }

  minimizeSidepanel() {
    this.isMaximized = false;
  }

  closeSidepanel() {
    this.showSidepanel = false;
    this.isMaximized = false;
  }
}
